var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9481 3.28467C43.8528 1.53688 42.4628 0.147027 40.715 0.0516375C37.1883 -0.141033 30.2873 0.0463955 23.6883 3.45955C20.3244 5.1996 16.7666 8.14973 13.9273 11.5535C13.8923 11.5955 13.8583 11.6376 13.8236 11.6797L7.38002 12.1774C6.31939 12.2594 5.37469 12.8153 4.78808 13.7025L0.392065 20.3516C-0.0528297 21.0245 -0.123556 21.8666 0.202747 22.6042C0.529135 23.3419 1.19979 23.856 1.99685 23.9795L7.42557 24.8203C7.4064 24.9258 7.38716 25.0312 7.36954 25.1368C7.18881 26.2179 7.547 27.3294 8.32782 28.1101L15.8896 35.672C16.5369 36.3193 17.4117 36.6762 18.308 36.6762C18.4926 36.6762 18.6782 36.661 18.863 36.6301C18.9685 36.6125 19.074 36.5933 19.1795 36.5741L20.0203 42.0029C20.1438 42.8 20.6579 43.4707 21.3954 43.797C21.7023 43.9328 22.027 43.9998 22.3503 43.9998C22.8043 43.9998 23.2551 43.8676 23.648 43.6078L30.2972 39.2117C31.1845 38.625 31.7403 37.6803 31.8221 36.6198L32.3199 30.1763C32.3619 30.1416 32.4042 30.1075 32.4461 30.0726C35.85 27.2333 38.8002 23.6755 40.5401 20.3114C43.9535 13.7122 44.1405 6.81109 43.9481 3.28467ZM28.8753 37.061L22.5151 41.2662L21.6956 35.9755C24.3837 35.1851 27.0428 33.9193 29.5761 32.2235L29.2519 36.4211C29.2317 36.6829 29.0944 36.9162 28.8753 37.061ZM17.7126 33.849L10.1507 26.2871C9.95778 26.0941 9.86858 25.823 9.91232 25.5618C10.1371 24.2175 10.4865 22.9378 10.9189 21.7323L22.265 33.0784C20.8171 33.597 19.5202 33.9064 18.4379 34.0874C18.1763 34.1308 17.9055 34.0419 17.7126 33.849ZM7.57862 14.7479L11.7761 14.4236C10.0802 16.957 8.81439 19.6161 8.02403 22.3042L2.73342 21.4848L6.93865 15.1244C7.08354 14.9053 7.31686 14.7681 7.57862 14.7479ZM30.7949 28.0927C28.7124 29.8297 26.6909 31.0861 24.8276 31.9952L12.004 19.1716C13.1949 16.7393 14.6484 14.7138 15.907 13.205C18.5345 10.0549 21.8025 7.33754 24.8729 5.74942C30.9292 2.61677 37.3101 2.44807 40.5747 2.62579C41.0068 2.64934 41.3504 2.993 41.374 3.42518C41.552 6.68974 41.3829 13.0706 38.2503 19.127C36.6622 22.1973 33.9448 25.4651 30.7949 28.0927Z",
    fill: "url(#paint0_linear_303_276)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1404 20.3018C31.7906 20.3016 33.4414 19.6734 34.6977 18.4171C35.9151 17.1998 36.5854 15.5813 36.5854 13.8598C36.5854 12.1383 35.915 10.5197 34.6977 9.30245C32.1848 6.7894 28.0959 6.78957 25.5831 9.30245C24.3657 10.5197 23.6953 12.1383 23.6953 13.8598C23.6953 15.5813 24.3658 17.1998 25.5831 18.4171C26.8397 19.6737 28.4896 20.3019 30.1404 20.3018ZM27.4059 11.1253C28.1597 10.3714 29.15 9.9945 30.1402 9.9945C31.1306 9.9945 32.1208 10.3714 32.8747 11.1253C33.605 11.8557 34.0072 12.8268 34.0072 13.8597C34.0072 14.8926 33.605 15.8637 32.8747 16.5941C31.367 18.1019 28.9136 18.1018 27.4058 16.5941C26.6754 15.8637 26.2732 14.8926 26.2732 13.8598C26.2732 12.8269 26.6755 11.8557 27.4059 11.1253Z",
    fill: "url(#paint1_linear_303_276)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3144 36.2599C1.64431 36.2599 1.97422 36.1341 2.22585 35.8823L6.43443 31.6737C6.93785 31.1703 6.93785 30.3541 6.43443 29.8507C5.9311 29.3473 5.11487 29.3473 4.61145 29.8507L0.402954 34.0593C-0.100464 34.5627 -0.100464 35.3789 0.402954 35.8823C0.654577 36.134 0.984489 36.2599 1.3144 36.2599Z",
    fill: "url(#paint2_linear_303_276)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2918 33.7076C9.78851 33.2042 8.97228 33.2042 8.46886 33.7076L0.377564 41.799C-0.125855 42.3024 -0.125855 43.1186 0.377564 43.622C0.629273 43.8737 0.959099 43.9995 1.28901 43.9995C1.61892 43.9995 1.94883 43.8737 2.20046 43.6219L10.2918 35.5306C10.7953 35.0272 10.7953 34.2111 10.2918 33.7076Z",
    fill: "url(#paint3_linear_303_276)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3264 37.5646L8.1178 41.7732C7.61438 42.2766 7.61438 43.0927 8.1178 43.5961C8.36951 43.8479 8.69942 43.9737 9.02924 43.9737C9.35907 43.9737 9.68907 43.8479 9.94069 43.5961L14.1493 39.3876C14.6527 38.8841 14.6527 38.068 14.1493 37.5646C13.6459 37.0612 12.8297 37.0612 12.3264 37.5646Z",
    fill: "url(#paint4_linear_303_276)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_276",
    x1: 21.9998,
    y1: 0,
    x2: 21.9998,
    y2: 43.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_276",
    x1: 30.1404,
    y1: 7.41772,
    x2: 30.1404,
    y2: 20.3018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_276",
    x1: 3.41869,
    y1: 29.4731,
    x2: 3.41869,
    y2: 36.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_276",
    x1: 5.3347,
    y1: 33.3301,
    x2: 5.3347,
    y2: 43.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_303_276",
    x1: 11.1335,
    y1: 37.187,
    x2: 11.1335,
    y2: 43.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoketIcon);
export default __webpack_public_path__ + "static/media/roket-icon.384a7fb5a202dec5a91b2b9e614a3a40.svg";
export { ForwardRef as ReactComponent };